import { deflate } from 'zlib';

const debug = require('../../../../../node_modules/debug')('log4js:fileSync');
const path = require('path');
const os = require('os');
const utils = require("../../../Utils/DateUtils");
const JSZip = require("../../../../../node_modules/jszip");


const eol = os.EOL || '\n';

const LOG_DATABASE_NAME = "LOG_DATABASE";
const LOG_DATABASE_VERSION = "3";
let logDatabase = null;
const LOG_TAG = "fileSync_chome";

async function openDatabase(storeNamesList) {
    return new Promise((resolve, reject) => {

        // let openRequest = window.indexedDB.open(LOG_DATABASE_NAME, LOG_DATABASE_VERSION);
        let openRequest = indexedDB.open(LOG_DATABASE_NAME, LOG_DATABASE_VERSION);

        openRequest.onupgradeneeded = function (event) {
            // triggers if the client had no database
            // ...perform initialization...
            console.error(utils.getTimeStamp(), LOG_TAG, "logDatabase onupgradeneeded");
            // var store = evt.currentTarget.result.createObjectStore(LOG_STORE_NAME, { keyPath: 'id', autoIncrement: true });
            // event.currentTarget.result.createObjectStore(LOG_STORE_NAME, { keyPath: 'id', autoIncrement: true });
            storeNamesList.forEach((store) => {
                let objectStoreIndex = Object.values(event.currentTarget.result.objectStoreNames).indexOf(store);
                if (objectStoreIndex < 0) {
                    event.currentTarget.result.createObjectStore(store, { autoIncrement: true });
                }
            });
        };

        openRequest.onsuccess = function (event) {
            console.error(utils.getTimeStamp(), LOG_TAG, "logDatabase onsuccess");
            logDatabase = openRequest.result;
            resolve(logDatabase);
        };

        openRequest.onerror = function (event) {
            console.error(utils.getTimeStamp(), "Error", openRequest.error);
            // reject();
        };
    });
}

/**
 * @param {string} store_name
 * @param {string} mode either "readonly" or "readwrite"
 */
function getObjectStore(store_name, mode) {
    let transaction = null;
    try {
        transaction = logDatabase.transaction(store_name, mode);
    } catch (error) {
        console.error(utils.getTimeStamp(), LOG_TAG, "getObjectStore error:", error);
    }

    return transaction ? transaction.objectStore(store_name) : null;
}

function clearObjectStore(store_name) {
    return new Promise((resolve, reject) => {
        const store = getObjectStore(store_name, 'readwrite');
        if (!store) {
            console.error(utils.getTimeStamp(), LOG_TAG, "clearObjectStore Object Store " + store_name + " not found");
            reject();
        }

        let req = store.clear();
        req.onsuccess = function (event) {
            // console.error(utils.getTimeStamp(), "clearObjectStore: Store cleared:", event.target.source.name);
            resolve();
        };
        req.onerror = function (event) {
            console.error(utils.getTimeStamp(), "clearObjectStore error:", event.target.errorCode);
            // reject();
        };
    });
}

function getFilesInDirectory() {
    const obj = Object.values(logDatabase.objectStoreNames);
    return obj;
}

function getFileData(store_name) {
    return new Promise((resolve, reject) => {
        const store = getObjectStore(store_name, 'readonly');
        let data = [];

        if (!store) {
            console.error(utils.getTimeStamp(), LOG_TAG, "getFileData Object Store " + store_name + " not found");
            resolve(data);
        }

        const req = store.openCursor();
        req.onsuccess = function (event) {
            var cursor = event.target.result;
            if (cursor) {
                data.push(cursor.value);
                cursor.continue();
            } else {
                // console.log(utils.getTimeStamp(), "getFileData Got all items.", event.target.source.name);
                resolve({ name: event.target.source.name, data: data });
            }
        };
        req.onerror = function (event) {
            console.error(utils.getTimeStamp(), "getFileData error:", event.error);
            // reject();
        }
    });
}

function getLogFileSize(store_name) {
    return new Promise((resolve, reject) => {
        const store = getObjectStore(store_name, 'readonly');
        let size = 0;

        if (!store) {
            console.error(utils.getTimeStamp(), LOG_TAG, "getLogFileSize Object Store " + store_name + "not found");
            resolve(size);
        }

        const req = store.openCursor();
        req.onsuccess = function (event) {
            var cursor = event.target.result;
            if (cursor) {
                size += cursor.value.length;
                cursor.continue();
            } else {
                // console.log(utils.getTimeStamp(), "getLogFileSize Got all items.", event.target.source.name);
                resolve(size);
            }
        };
        req.onerror = function (event) {
            console.error(utils.getTimeStamp(), "getLogFileSize error:", event.error);
            // reject();
        }
    });
}

function renameFile(store_name, new_store_name) {
    return new Promise(async (resolve, reject) => {
        const dataFile = await getFileData(store_name);
        await clearObjectStore(store_name);

        const new_store = getObjectStore(new_store_name, 'readwrite');
        if (!new_store) {
            console.error(utils.getTimeStamp(), LOG_TAG, "renameFile Object Store " + new_store + " not found");
            reject();
        }

        let data = [];
        if (dataFile) {
            data = dataFile.data;
        } else {
            resolve();
        }

        data.forEach(function (item, i) {
            const req = new_store.add(item);
            req.onsuccess = function (event) {
                if (i === data.length - 1) {
                    // console.log(utils.getTimeStamp(), "renameFile add success.", event.target.source.name);
                    resolve();
                }
            };
            req.onerror = function (event) {
                console.error(utils.getTimeStamp(), "renameFile write to new_store error:", event.target.errorCode);
                if (i === data.length - 1) {
                    reject();
                }
            };
        });
    });
}

class RollingFileSync {
    constructor(filename, size, backups, options) {
        debug(utils.getTimeStamp(), 'In RollingFileStream');

        function throwErrorIfArgumentsAreNotValid() {
            if (!filename || !size || size <= 0) {
                throw new Error('You must specify a filename and file size');
            }
        }

        throwErrorIfArgumentsAreNotValid();

        this.filename = filename;
        this.size = size;
        this.backups = backups || 1;
        this.options = options;
        this.currentSize = 0;

        async function currentFileSize(filename) {
            let fileSize = 0;

            try {
                fileSize = await getLogFileSize(filename);
            } catch (e) {
                // file does not exist
            }
            return fileSize;
        }

        currentFileSize(filename).then((result) => {
            this.currentSize = result
            debug(utils.getTimeStamp(), 'In RollingFileStream got size size:', this.currentSize);
        });

        debug(utils.getTimeStamp(), 'In RollingFileStream current size:', this.currentSize);
    }

    shouldRoll() {
        // debug(utils.getTimeStamp() + ' should roll with current size %d, and max size %d', this.currentSize, this.size);
        return this.currentSize >= this.size;
    }

    roll(filename) {
        const that = this;
        const nameMatcher = new RegExp(`^${path.basename(filename)}`);

        function justTheseFiles(item) {
            return nameMatcher.test(item);
        }

        function index(filename_) {
            return parseInt(filename_.substring((`${path.basename(filename)}.`).length), 10) || 0;
        }

        function byIndex(a, b) {
            if (index(a) > index(b)) {
                return 1;
            }
            if (index(a) < index(b)) {
                return -1;
            }

            return 0;
        }

        function increaseFileIndex(fileToRename) {
            const idx = index(fileToRename);
            // debug(utils.getTimeStamp(), `Index of ${fileToRename} is ${idx}`);
            if (idx === that.backups - 1) {
                clearObjectStore(fileToRename);
            } else if (idx < that.backups - 1) {
                // debug(utils.getTimeStamp(), `Renaming ${fileToRename} -> ${filename}.${idx + 1}`);
                renameFile(fileToRename, `${filename}.${idx + 1}`);
            }
        }

        function renameTheFiles() {
            // roll the backups (rename file.n to file.n+1, where n <= numBackups)
            // debug(utils.getTimeStamp(), 'Renaming the old files');

            // const files = fs.readdirSync(path.dirname(filename));
            const files = getFilesInDirectory();
            files.filter(justTheseFiles).sort(byIndex).reverse().forEach(increaseFileIndex);
        }

        debug(utils.getTimeStamp(), 'Rolling, rolling, rolling');
        renameTheFiles();
    }

    /* eslint no-unused-vars:0 */
    write(chunk, encoding) {
        const that = this;

        async function writeTheChunk() {
            // debug(utils.getTimeStamp(), 'writing the chunk to the file');
            that.currentSize += chunk.length;
            // fs.appendFileSync(that.filename, chunk);

            const store = getObjectStore(that.filename, 'readwrite');
            let req;
            try {
                req = store.add(chunk);
                // req.onsuccess = function (event) {
                //   console.log(utils.getTimeStamp(), "writeTheChunk in DB successful", event.target.result, " in:", event.target.source.name);
                // };
                // req.onerror = function (event) {
                //   console.error(utils.getTimeStamp(), "writeTheChunk error:", event.target.errorCode);
                // };
            } catch (error) {
                console.error(utils.getTimeStamp(), "writeTheChunk error:", error);
            }
        }

        // debug(utils.getTimeStamp(), 'in write');

        if (this.shouldRoll()) {
            this.currentSize = 0;
            this.roll(this.filename);
        }

        writeTheChunk();
    }

    getZippedLogFile() {
        // debug(utils.getTimeStamp(), 'getZipFile');
        const that = this;
        const nameMatcher = new RegExp(`^${path.basename(that.filename)}`);

        function justTheseFiles(item) {
            return nameMatcher.test(item);
        }

        function index(filename_) {
            return parseInt(filename_.substring((`${path.basename(that.filename)}.`).length), 10) || 0;
        }

        function byIndex(a, b) {
            if (index(a) > index(b)) {
                return 1;
            }
            if (index(a) < index(b)) {
                return -1;
            }

            return 0;
        }

        const promiseArray = [];
        const files = getFilesInDirectory();
        files.filter(justTheseFiles).sort(byIndex).reverse().forEach(function (file) {
            promiseArray.push(getFileData(file));
        });

        return new Promise((resolve, reject) => {
            const zip = new JSZip();
            // zip.file("Hello.txt", "Hello World\n");
            // zip.generateAsync({ type: "blob" })
            //   .then(function (content) {
            //     // see FileSaver.js
            //     // saveAs(content, "example.zip");
            //   });

            Promise.all(promiseArray)
                .then(results => {
                    results.forEach(file => {
                        zip.file(file.name, file.data.join(""));
                    });
                    zip.generateAsync({ type: "blob", compression: "DEFLATE" }) //type: uint8array, blob,... ;compression : STORE : no compression; DEFLATE compression
                        .then(function (content) {
                            resolve(content);
                        });
                })
                .catch(error => {
                    reject(error);
                });
        });
    }
}

/**
 * File Appender writing the logs to a text file. Supports rolling of logs by size.
 *
 * @param file file log messages will be written to
 * @param layout a function that takes a logevent and returns a string
 *   (defaults to basicLayout).
 * @param logSize - the maximum size (in bytes) for a log file,
 *   if not provided then logs won't be rotated.
 * @param numBackups - the number of log files to keep after logSize
 *   has been reached (default 5)
 * @param timezoneOffset - optional timezone offset in minutes
 *   (default system local)
 * @param options - passed as is to fs options
 */
function fileAppender(file, layout, logSize, numBackups, timezoneOffset, options) {
    debug(utils.getTimeStamp(), 'fileSync appender created');
    file = path.normalize(file);
    numBackups = numBackups === undefined ? 5 : numBackups;
    // there has to be at least one backup if logSize has been specified
    numBackups = numBackups === 0 ? 1 : numBackups;

    function openTheStream(filePath, fileSize, numFiles) {
        let stream;

        if (fileSize) {
            stream = new RollingFileSync(
                filePath,
                fileSize,
                numFiles,
                options
            );
        }

        return stream;
    }

    // fileSystem = await etFileSystem(logSize, numBackups);
    const logFile = openTheStream(file, logSize, numBackups);

    // return (loggingEvent) => {
    // return function (loggingEvent) {
    //   logFile.write(layout(loggingEvent, timezoneOffset) + eol);
    // };
    function write(loggingEvent) {
        logFile.write(layout(loggingEvent, timezoneOffset) + eol);
    };

    function getZippedLogFile() {
        return logFile.getZippedLogFile();
    };

    return { write: write, zip: getZippedLogFile };
}

function createObjectStoreList(baseStoreName, number) {
    let objectStorList = [baseStoreName];
    for (let i = 1; i < number; i++) {
        objectStorList.push(baseStoreName + "." + i);
    }
    return objectStorList;
}

export async function configure(config, layouts) {
    await openDatabase(createObjectStoreList(config.filename, config.backups));
    let layout = layouts.basicLayout;
    if (config.layout) {
        layout = layouts.layout(config.layout.type, config.layout);
    }

    const options = {
        flags: config.flags || 'a',
        encoding: config.encoding || 'utf8',
        mode: config.mode || 0o644
    };

    return fileAppender(
        config.filename,
        layout,
        config.maxLogSize,
        config.backups,
        config.timezoneOffset,
        options
    );
}

// module.exports.configure = configure;